// extracted by mini-css-extract-plugin
export default {"wrapper":"navigation__wrapper__TWr7w","container":"navigation__container__vhelT","item":"navigation__item__YHmBo","link":"navigation__link__tYfuz"};